import React from 'react';

import PropTypes from 'prop-types';
import { Segment, Radio, Button, Form } from 'semantic-ui-react';

import _isEmpty from 'lodash/isEmpty';

import MarkdownField from 'components/fields/MarkdownField';
import { ANSWER_VALIDATION } from 'components/modules/questions/constants';
import { AnswerType } from 'components/modules/questions/types';

import { ANSWER_MARKDOWN_FIELD_OPTIONS } from './AnswerItem.constants';

import './AnswerItem.scss';

const propTypes = {
  answer: AnswerType.isRequired,
  index: PropTypes.number.isRequired,
  answerErrors: PropTypes.shape({ text: PropTypes.string }),
  onAnswerChange: PropTypes.func.isRequired,
  onAnswerDelete: PropTypes.func.isRequired,
  onPreferredChange: PropTypes.func.isRequired,
  canDelete: PropTypes.bool.isRequired,
  isPreferred: PropTypes.bool.isRequired,
};

const defaultProps = {
  answerErrors: {},
};

function AnswerItem({
  answer,
  index,
  answerErrors,
  onAnswerChange: onAnswerChangeProp,
  onAnswerDelete: onAnswerDeleteProp,
  onPreferredChange: onPreferredChangeProp,
  canDelete,
  isPreferred,
}) {
  const hasError = answerErrors && !_isEmpty(answerErrors);

  function onTextChange(value) {
    const nextValue =
      value.length > ANSWER_VALIDATION.MAX_LENGTH
        ? value.slice(0, ANSWER_VALIDATION.MAX_LENGTH)
        : value;
    onAnswerChangeProp(index, 'text', nextValue);
  }

  function onPreferredChangeClick() {
    onPreferredChangeProp(index);
  }

  function onDeleteClick() {
    onAnswerDeleteProp(index);
  }

  return (
    <Segment className={`answer-item ${hasError ? 'error' : ''} ${isPreferred ? 'preferred' : ''}`}>
      <div className="answer-header">
        <div className="answer-controls">
          <Radio
            label={isPreferred ? 'Preferred Answer ⭐' : 'Set as Preferred'}
            checked={answer.isPreferred}
            onChange={onPreferredChangeClick}
          />
          {canDelete && (
            <Button
              className="delete-red compact"
              icon="trash"
              onClick={onDeleteClick}
              title="Delete answer"
            />
          )}
        </div>
      </div>
      <Form.Field error={hasError}>
        <label htmlFor={`answer-text-${index}`}>Answer</label>
        <MarkdownField
          id={`answer-text-${index}`}
          value={answer.text}
          onChange={onTextChange}
          options={ANSWER_MARKDOWN_FIELD_OPTIONS}
        />
        {hasError && <div className="field-error">{answerErrors && answerErrors.text}</div>}
        <div className="character-count">
          {answer.text.length}/{ANSWER_VALIDATION.MAX_LENGTH}
        </div>
      </Form.Field>
    </Segment>
  );
}

AnswerItem.propTypes = propTypes;
AnswerItem.defaultProps = defaultProps;

export default AnswerItem;
